<template>
    <v-card>
        <v-container>
            <v-card-title>{{ $t('passwordLost.title') }}</v-card-title>

            <v-card-text v-if="blocked && errorMessage">
                <v-alert dense outlined type="error">
                    {{ errorMessage }}
                </v-alert>
            </v-card-text>

            <v-card-text v-else-if="noQuestions" dense outlined type="error" data-cy="resetPasswordMessageError">
                {{ $t('passwordLost.questions.errorConfiguration') }}
            </v-card-text>
            <v-card-text v-else>
                <p>{{ $t('passwordLost.questions.help_us') }}</p>
                <p>
                    {{ $t('passwordLost.questions.your_id') }} <b>{{ login }}</b>
                </p>
                <p>{{ $t('passwordLost.questions.please_answer') }}</p>
                <br />
                <div class="challenge" v-for="(question, index) in sqUser" :key="index">
                    <b>{{ $t('passwordLost.questions.question', { number: index + 1 }) }}</b>
                    <p>{{ question }}</p>
                    <b>{{ $t('passwordLost.questions.answer') }}</b>
                    <v-text-field
                        color="#3200E6"
                        :label="$t('passwordLost.questions.your_answer')"
                        v-model="answers[index]"
                        :data-cy="'questionsAnswers' + index"
                    ></v-text-field>
                </div>

                <v-alert v-if="retryMessage" dense outlined type="error" data-cy="resetPasswordErrorMessage">
                    {{ retryMessage }}
                </v-alert>
                <p v-else>
                    {{ $t('passwordLost.questions.remainingAttempts', { remaining: remaining }) }}
                </p>

                <div class="actions">
                    <v-btn class="secondary-action" @click="cancel" data-cy="resetPasswordCancel">
                        {{ $t('passwordLost.prev') }}
                    </v-btn>
                    <v-btn
                        class="action"
                        :disabled="!isValid || checking"
                        :loading="checking"
                        @click="submit"
                        data-cy="resetSecretSubmit"
                    >
                        {{ $t('passwordLost.next') }}
                    </v-btn>
                </div>
            </v-card-text>
        </v-container>
    </v-card>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            login: null,
            sqUser: null,
            answers: [],
            errorMessage: null,
            blocked: false,
            noQuestions: false,
            retryMessage: null,
            checking: false,
            remaining: null
        };
    },
    methods: {
        cancel() {
            this.$router.push('/password-lost');
        },
        async submit() {
            const data = {
                geodisLogin: this.login,
                secretQuestions: [
                    {
                        secretQuestion: this.sqUser[0],
                        secretAnswer: this.answers[0]
                    },
                    {
                        secretQuestion: this.sqUser[1],
                        secretAnswer: this.answers[1]
                    }
                ]
            };

            // Use axios directly to properly catch blocking errors
            try {
                this.checking = true;
                const response = await axios.post(`${window.location.origin}/api/v1/passaccount/sq/check`, data, {
                    withCredentials: true
                });
                this.checking = false;
                const result = response.data;

                this.errorMessage = null;
                this.retryMessage = null;
                this.answers[0] = this.answers[1] = null;

                if (result.ok) {
                    this.$router.push('/password-lost/change');
                } else if (!result.canRetry) {
                    // User is blocked
                    this.blocked = true;
                    const msg = result.errorMessage;
                    this.errorMessage =
                        (msg && msg[this.$i18n.locale]) || (msg && msg.en) || this.$t('passwordLost.questions.error');
                } else {
                    // Wrong answer but can still retry
                    this.retryMessage = this.$t('passwordLost.questions.wrongAnswer', { remaining: result.remaining });
                }
            } catch (error) {
                const data = error.response?.data;
                if (data && data.canRetry === false) {
                    this.blocked = true;
                    const msg = data.errorMessage;
                    this.errorMessage =
                        (msg && msg[this.$i18n.locale]) ||
                        (msg && msg.en) ||
                        data.message ||
                        this.$t('passwordLost.questions.error');
                } else {
                    this.errorMessage = data?.message || null;
                }
                this.answers[0] = this.answers[1] = null;
            }
        }
    },
    computed: {
        isValid: function () {
            return this.answers[0] && this.answers[1];
        }
    },
    created() {
        const data = this.$session.get('passwordlost-data');
        const attemptStatusData = this.$session.get('attempt-status');
        if (attemptStatusData) {
            const attemptStatus = JSON.parse(decodeURIComponent(escape(atob(attemptStatusData))));
            if (attemptStatus && attemptStatus.remaining) {
                this.remaining = attemptStatus.remaining;
            }
        }
        if (data) {
            const informations = JSON.parse(decodeURIComponent(escape(atob(data))));
            this.login = informations.userInformations.geodisLogin;
            const sqUser = informations.sqUser.filter(sq => sq);
            this.sqUser = sqUser;
            if (!this.sqUser || this.sqUser.length === 0) {
                this.noQuestions = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.v-text-field {
    width: 400px;
}

.challenge {
    margin-top: 20px;
    p {
        margin-top: 5px;
    }
}

.v-alert {
    // width: 400px;
}

.actions {
    margin-top: 20px;
    button {
        margin-right: 10px;
    }
}
</style>
